import { AuthService } from './../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ExpedientesService } from './../../services/expedientes.service';
import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { NgForm } from '../../../../node_modules/@angular/forms';

@Component({
  selector: 'app-preconsulta',
  templateUrl: './preconsulta.component.html',
  styleUrls: ['./preconsulta.component.css']
})
export class PreconsultaComponent implements OnInit {

  @ViewChild("mensajeError") mensajeError:ElementRef;
  @ViewChild("mensajeError2") mensajeError2:ElementRef;
  @ViewChild("caracteres") caracteres:ElementRef;
  email:string;
  email2:string;
  proteccionDatos:boolean=false;
  proteccionDatos2:boolean=false;
  codigo:string;
  charsTexto:number=2000;

  formulario={
    nombre: "",
    email:"",
    telefono:"",
    titulo:"",
    descripcion:"",
    tipo:"consulta"
  };

  nombreArchivo1;
  nombreArchivo2;
  nombreArchivo3;
  nombreArchivo4;
  nombreArchivo5;

  nombresArchivos;
  archivos;
  
  
  @ViewChild("subirArchivo")  archivoSubido: ElementRef;
  @ViewChild("subirArchivo2") archivoSubido2: ElementRef;
  @ViewChild("subirArchivo3") archivoSubido3: ElementRef;
  @ViewChild("subirArchivo4") archivoSubido4: ElementRef;
  @ViewChild("subirArchivo5") archivoSubido5: ElementRef;

  constructor(private renderer:Renderer2, private expedientesService:ExpedientesService,
              private router:Router, private activatedRoute:ActivatedRoute, private auth:AuthService) {
    if(this.auth.usuarioActivo){
      this.auth.usuarioActivo=null;
      this.auth.loggedIn.next(false);
      localStorage.removeItem("token");
    }
  }

  ngOnInit() {
    this.activatedRoute.queryParams
    .subscribe(params=>{
      this.codigo=params["c"];
    });
    if(this.codigo){
      this.cargarCliente();
    }
  }

  cargarCliente(){
    this.expedientesService.cargarClienteWeb(this.codigo)
    .subscribe(resp=>{
      if(resp["err"]==false){
        this.formulario.email=resp["email"];
      }else{
        window.location.href="https://solucionlegal.es";
      }
    });
  }

  guardarPreconsulta(myform:NgForm){
    
    if(this.proteccionDatos){
      if(myform.valid){
        
        if(this.email===this.email2){
          
          this.expedientesService.guardarPreconsulta(this.email)
          .subscribe(resp=>{
            if(resp["err"]==false){
              alert(resp["msg"]);
              window.top.location.href='https://www.solucionlegal.es/';
            }else{
              let text=this.renderer.createText(resp["msg"]);
              this.renderer.appendChild(this.mensajeError.nativeElement, text);
              this.renderer.setStyle(this.mensajeError.nativeElement, "color", "red");
              setTimeout(() => {
                this.renderer.removeChild(this.mensajeError.nativeElement, text);
              }, 1500);
            }
          });
        }else{
          let text=this.renderer.createText("Las direcciones de correo introducidas no coinciden.");
          this.renderer.appendChild(this.mensajeError.nativeElement, text);
          this.renderer.setStyle(this.mensajeError.nativeElement, "color", "red");
          setTimeout(() => {
            this.renderer.removeChild(this.mensajeError.nativeElement, text);
          }, 1500);
        }
      }else{
        let text=this.renderer.createText("Hay errores en el formulario.");
        this.renderer.appendChild(this.mensajeError.nativeElement, text);
        this.renderer.setStyle(this.mensajeError.nativeElement, "color", "red");
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeError.nativeElement, text);
        }, 1500);
      }
    }else{
      let text=this.renderer.createText("Debes aceptar la cláusula de protección de datos.");
      this.renderer.appendChild(this.mensajeError.nativeElement, text);
      this.renderer.setStyle(this.mensajeError.nativeElement, "color", "red");
      setTimeout(() => {
        this.renderer.removeChild(this.mensajeError.nativeElement, text);
      }, 1500);
    }
  }

  crearExpediente(myform:NgForm){
    let textoAceptar="A continuación debe realizar el pago correspondiente a su consulta\n\n"
                    +"Una vez efectuado, su consulta será enviada a nuestro departamento jurídico para su tramitación.\n\n"
                    +"Gracias por confiar en SOLUCIONLEGAL";
    
    if(this.proteccionDatos2){              
      if(myform.valid){
        if(confirm(textoAceptar)){
          let expediente={};
          expediente['EXweb']=1;
          expediente['EXtitulo']=this.formulario.titulo;
          expediente['EXnombre']=this.formulario.nombre;
          expediente['EXemail']=this.formulario.email;
          expediente['EXtelefono']=this.formulario.telefono;
          expediente['EXdescripcion']=this.formulario.descripcion;
          expediente['EXregistrado']=0;
          expediente['EXpagado']=0;
          
          if(this.formulario.tipo=="consulta"){
            expediente['EXconsulta']=1;
            this.expedientesService.insertExpedienteWeb(expediente)
            .subscribe(resp=>{
              
              this.router.navigate(["/consulta","consultalegal"]);
            });
          }else if(this.formulario.tipo="estudio"){
            expediente['EXestudio']=1;

            this.nombresArchivos=[
              this.nombreArchivo1,
              this.nombreArchivo2,
              this.nombreArchivo3,
              this.nombreArchivo4,
              this.nombreArchivo5
            ];
        
            this.archivos=[
              this.archivoSubido,
              this.archivoSubido2,
              this.archivoSubido3,
              this.archivoSubido4,
              this.archivoSubido5
            ];

            this.expedientesService.insertExpedienteWeb(expediente).subscribe(resp=>{
            
            for(let i=0;i<this.archivos.length;i++){
              
              if(this.archivos[i] && this.archivos[i].nativeElement.files.length>0){
                
                let adjunto={ EDcodexpediente : resp["id_introducido"],
                              EDdescripcion: this.nombresArchivos[i]};
                
                this.insertarAdjunto(adjunto, this.archivos[i].nativeElement.files[0]);              
              }
            }
            this.router.navigate(["/consulta","estudiolegal"]);
            });
          }
        }
      }else{
          let text=this.renderer.createText("Faltan datos por rellenar en el formulario");
          this.renderer.appendChild(this.mensajeError2.nativeElement, text);
          this.renderer.setStyle(this.mensajeError2.nativeElement, "color", "red");
          setTimeout(() => {
            this.renderer.removeChild(this.mensajeError2.nativeElement, text);
          }, 1500);
      }
    }else{
      let text=this.renderer.createText("Debes aceptar la cláusula de protección de datos.");
        this.renderer.appendChild(this.mensajeError2.nativeElement, text);
        this.renderer.setStyle(this.mensajeError2.nativeElement, "color", "red");
        setTimeout(() => {
          this.renderer.removeChild(this.mensajeError2.nativeElement, text);
        }, 1500);
    }

  }

  insertarAdjunto(adjunto, archivo){
    this.expedientesService.insertAdjuntoWeb(adjunto, archivo).subscribe();
  }

  contarCaracteres(event){
    let chars=(2000-event.target.value.length);
    this.charsTexto=chars;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/preconsulta/preconsulta.component.ts